<template>
  <v-loader>
  </v-loader>
</template>
<script>
import {mapActions, mapState} from 'vuex'
export default {
  data: () => {
    return {}
  },
  computed: {
    ...mapState('user', ['profile'])
  },
  methods: {
    ...mapActions('user', ['getProfile', 'setProfile'])
  },
  async mounted() {
    if (!this.$route.query.code) {
      this.$router.push({path: '/404'})
    }
    await this.getProfile()
    this.setProfile({...this.profile, ...{ discordCode:  this.$route.query.code } })
    this.$router.push({path: 'profile'})
  }
}
</script>
